export { default } from './lozenge';
export type {
	NewLozengeProps,
	LozengeColor as NewLozengeColor,
	LozengeSpacing,
	SemanticColor,
	AccentColor,
} from './types';
